import { render, staticRenderFns } from "./HeaderMenuItem.vue?vue&type=template&id=b7db205e&scoped=true&"
import script from "./HeaderMenuItem.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMenuItem.vue?vue&type=style&index=0&id=b7db205e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7db205e",
  null
  
)

export default component.exports